import Swiper, { Autoplay, EffectFade, Navigation } from 'swiper';

const mobileExpertiseMediaQuery = '(max-width: 640px)';
const initializedWrappers = new WeakSet();

const hydrateSlide = (slide) => {
  if (!slide || slide.dataset.expertiseMobileLoaded === 'true') {
    return;
  }

  slide.querySelectorAll('source[data-srcset]').forEach((source) => {
    source.srcset = source.dataset.srcset;
    delete source.dataset.srcset;
  });

  slide.querySelectorAll('img[data-src]').forEach((image) => {
    image.src = image.dataset.src;
    delete image.dataset.src;
  });

  slide.dataset.expertiseMobileLoaded = 'true';
};

const hydrateVisibleSlides = (swiper) => {
  const slides = Array.from(swiper.slides || []);

  if (!slides.length) {
    return;
  }

  const visibleIndices = [
    swiper.activeIndex,
    swiper.activeIndex - 1,
    swiper.activeIndex + 1,
  ];

  visibleIndices.forEach((index) => {
    hydrateSlide(slides[(index + slides.length) % slides.length]);
  });
};

const initExpertiseMobileSwiper = (scope = document) => {
  const wrappers = scope.matches?.('[data-expertise-mobile-swiper]')
    ? [scope]
    : Array.from(scope.querySelectorAll('[data-expertise-mobile-swiper]'));

  wrappers.forEach((wrapper) => {
    if (initializedWrappers.has(wrapper)) {
      return;
    }

    const swiperEl = wrapper.querySelector('.swiper');
    const nextEl = wrapper.querySelector('.swiper-button-next');
    const prevEl = wrapper.querySelector('.swiper-button-prev');
    const mobileMediaQuery = window.matchMedia(mobileExpertiseMediaQuery);

    if (!swiperEl || !nextEl || !prevEl) {
      return;
    }

    initializedWrappers.add(wrapper);

    let observer = null;
    let swiper = null;

    const createSwiper = () => {
      if (swiper || !mobileMediaQuery.matches) {
        return;
      }

      swiper = new Swiper(swiperEl, {
        modules: [Autoplay, EffectFade, Navigation],
        slidesPerView: 1,
        speed: 460,
        threshold: 10,
        watchOverflow: true,
        rewind: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        autoplay: {
          delay: 3500,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl,
          prevEl,
        },
        on: {
          afterInit: hydrateVisibleSlides,
          slideChangeTransitionStart: hydrateVisibleSlides,
        },
      });
    };

    const observeWrapper = () => {
      if (!mobileMediaQuery.matches || swiper || observer) {
        return;
      }

      if (typeof window.IntersectionObserver !== 'function') {
        createSwiper();
        return;
      }

      observer = new window.IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) {
          return;
        }

        observer.unobserve(wrapper);
        observer.disconnect();
        observer = null;
        createSwiper();
      }, {
        rootMargin: '300px 0px',
        threshold: 0.01,
      });
      observer.observe(wrapper);
    };

    const handleMediaQueryChange = () => {
      if (mobileMediaQuery.matches) {
        observeWrapper();
        return;
      }

      observer?.disconnect();
      observer = null;
      swiper?.destroy(true, true);
      swiper = null;
    };

    mobileMediaQuery.addEventListener('change', handleMediaQueryChange);
    observeWrapper();
  });
};

initExpertiseMobileSwiper();
window.initExpertiseMobileSwiper = initExpertiseMobileSwiper;
